import { reactive, ref, watch } from 'vue';
import _ from 'lodash';
export const useDataChangeDiff = () => {
  const changeFields = ref({});
  const oldValues = reactive({});
  const isChanged = ref(false);
  const currData = reactive({});
  const diffFields = (values, newValues) => {
    const isEqual = (v1, v2) => {
      if (Array.isArray(v1) && Array.isArray(v2)) {
        if (v1.length !== v2.length) {
          return false;
        }
        const max = v1.length;
        for (let i = 0; i < max; i++) {
          if (!isEqual(v1[i], v2[i])) {
            return false;
          }
        }
        return true;
      }
      if (typeof v1 === 'object' && typeof v2 === 'object') {
        const keys1 = Object.keys(v1);
        const keys2 = Object.keys(v2);
        if (keys1.length !== keys2.length) {
          return false;
        }
        for (const k of keys1) {
          if (!v2[k]) return false;
          if (!isEqual(v1[k], v2[k])) return false;
        }
        return true;
      }
      // object, array 类型不一致时直接判定为不等
      if (Array.isArray(v1) && !Array.isArray(v2) || !Array.isArray(v1) && Array.isArray(v2) || typeof v1 === 'object' && typeof v2 !== 'object' || typeof v1 !== 'object' && typeof v2 === 'object') {
        return false;
      }
      // 其他类型
      return v1 === v2;
    };
    const compareObject = (oldObj, newObj) => {
      const changeKeys = {};
      const addDiffField = (k, oldValue, newValue) => {
        changeKeys[k] = {
          oldValue,
          newValue
        };
      };
      const oldKeys = Object.keys(oldObj);
      const newKeys = Object.keys(newObj);
      // obj1与obj2的key对比
      for (const k of oldKeys) {
        if (!newObj[k]) {
          addDiffField(k, oldObj[k], null);
        } else if (!isEqual(oldObj[k], newObj[k])) {
          addDiffField(k, oldObj[k], newObj[k]);
        }
      }
      // obj2 与obj1的比较
      for (const k of newKeys) {
        if (!oldObj[k]) {
          addDiffField(k, null, newObj[k]);
        } else if (!isEqual(oldObj[k], newObj[k])) {
          addDiffField(k, oldObj[k], newObj[k]);
        }
      }
      return changeKeys;
    };
    changeFields.value = compareObject(values, newValues);
    isChanged.value = Object.keys(changeFields.value).length > 0;
  };
  const storeData = data => {
    const newValues = _.cloneDeep(data || {});
    for (const k of Object.keys(currData)) {
      delete currData[k];
    }
    Object.assign(currData, newValues);
    return newValues;
  };
  const storeDiffPoint = data => {
    for (const k of Object.keys(oldValues)) {
      delete oldValues[k];
    }
    for (const k of Object.keys(data)) {
      oldValues[k] = data[k];
    }
    changeFields.value = {};
    isChanged.value = false;
  };

  // 开始记录变动
  const start = data => {
    const tmp = storeData(toValue(data));
    storeDiffPoint(tmp);
    watch(() => data, val => {
      const newValues = storeData(val || {});
      const values = unref(oldValues);
      diffFields(values, newValues);
    }, {
      deep: true,
      immediate: false
    });
  };

  // 重置
  const reset = () => {
    for (const k of Object.keys(oldValues)) {
      delete oldValues[k];
    }
    changeFields.value = {};
    isChanged.value = false;
  };

  // 获取变动的字段列表
  const getChangeValues = () => {
    return changeFields.value || {};
  };
  return {
    isChanged,
    getChangeValues,
    reset,
    start
  };
};